const state = {
    salesorders: [],
    salesorderId: [],
    NewSalesOrder: {},
    inventoryStatus: [],
    loading: false,
    documents: [],
    file: null,
    docLoader: false,
};

export default state;